<template>
  <div id="app">
    <div class="banner">
      <h2>Real World Vue3</h2>
      <div id="nav">
        <router-link :to="{ name: 'EventList' }">Events</router-link> |
        <router-link :to="{ name: 'About' }">About</router-link>
      </div>
    </div>
    <router-view />
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#app *{
  box-sizing: border-box;
}

a {
  color: #2c3e50;
  text-decoration: none;
}

a:hover {
  color:#42b983;
}

h1 {
  font-size: 2.5em;
  color: #2c3e50;
}

.banner {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  max-width: 450px;
  margin: 0 auto;
  padding: 30px;
}

.banner > * {
  padding: 0;
  margin: 0;
}

#nav {
  padding: 0;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
